<template>
  <v-navigation-drawer location="start" permanent rail rail-width="60">
    <v-list density="compact" nav>
      <template v-for="t in tabs" :key="t">
        <v-sheet v-slot:default="length = filtered(this[t.storage]).length">
          <v-avatar
              :style="`cursor: ${length > 0 ? 'pointer' : 'default'}`"
              v-on:click="length > 0 ? activate_tab(t.name) : null"
              class="mb-2 d-flex justify-center flex-column align-center"
              :class="{ 'my-icon-button' : length > 0 }"
              :variant="tab === t.name ? 'outlined' : 'text'"
              rounded
              :color="length > 0 ? t.color : 'grey-lighten-2'"

              v-if="t.name === 'deleted' ? length > 0 : true"
          >
            <v-icon :icon="['fas', t.icon]" :shake="length > 0 && t.shake" :class="{ 'bigger' : !length > 0 }" />
            <p v-if="length > 0">{{ length }}</p>
          </v-avatar>
        </v-sheet>
      </template>
    </v-list>
  </v-navigation-drawer>

  <v-navigation-drawer location="start" v-if="tab">
    <Sorter__WP_Module />

    <v-sheet class="bottom_block">
      <Registered__WP_Widget v-if="tab === 'registered'" />
      <Appeals__WP_Widget v-if="tab === 'appeals'"  />
      <Maintenance__WP_Widget v-if="tab === 'maintenance'" />
      <Deleted__WP_Widget v-if="tab === 'deleted'" />
    </v-sheet>

  </v-navigation-drawer>
</template>

<script>

import Registered__WP_Widget from "@/components/wp_planner/widgets/registered.widget.wp.vue";
import { LeftDrawer } from "@/store/wp_planner/misc.store";
import Appeals__WP_Widget from "@/components/wp_planner/widgets/appeals.widget.wp.vue";
import { Reg_Documents } from "@/store/wp_planner/documents/registered.store";
import { App_Documents } from "@/store/wp_planner/documents/appeals.store";
import { Mai_Documents } from "@/store/wp_planner/documents/maintenance.store";
import Maintenance__WP_Widget from "@/components/wp_planner/widgets/maintenance.widget.wp.vue";
import { Del_Documents } from "@/store/wp_planner/documents/deleted.store";
import Deleted__WP_Widget from "@/components/wp_planner/widgets/deleted.widget.wp.vue";
import { FiltersBlock } from "@/store/wp_planner/filters.store";
import { MiniInfoBlock } from "@/store/wp_planner/info.store";
import Sorter__WP_Module from "@/components/wp_planner/module/sorter.module.vue";

export default {
  name: "Left__WP_Drawer",
  components: {
    Sorter__WP_Module,
    Deleted__WP_Widget,
    Maintenance__WP_Widget,
    Appeals__WP_Widget,
    Registered__WP_Widget
  },
  data() {
    return {
      tabs: [
        {
          name: 'registered',
          storage: 'registered',
          icon: 'fa-bell',
          color: 'deep-orange',
          shake: true,
          title: 'Зарегистрированные обращения'
        },
        {
          name: 'appeals',
          storage: 'appeals',
          icon: 'fa-triangle-exclamation',
          color: 'green-darken-4',
          shake: false,
          title: 'Обращения'
        },
        {
          name: 'maintenance',
          storage: 'maintenance',
          icon: 'fa-screwdriver-wrench',
          color: 'green-darken-4',
          shake: false,
          title: 'ТО и Испытания'
        },
        {
          name: 'deleted',
          storage: 'deleted',
          icon: 'fa-trash',
          color: 'grey',
          shake: false,
          title: 'Удалённые'
        }
      ]
    }
  },
  methods: {
    filtered: function (documents) {
      let docs = documents

      if (this.selected_filters.length > 0) {
        for (let filter of this.selected_filters) {
          docs = docs.filter(document => filter.data.includes(document[filter.id].guid))
        }
        return docs
      } else {
        return documents
      }
    },
    get_color: function (element) {
      if (element.storage) {
        if (element.name === 'deleted') {
          return 'red'
        }
        return this[element.storage] && this[element.storage].length > 0 ? 'grey-darken-4' : 'grey-darken-1'
      } else {
        return 'grey-darken-4'
      }

    },
    is_animated: function (element) {
      if (!element.storage) {
        return false
      } else {
        return !!(this[element.storage] && this[element.storage].length > 0)
      }

    },
    activate_tab: function (value) {
      if (this.tab && this.tab === value) {
        this.tab = null
      } else {
        this.tab = value
      }
    }
  },
  computed: {
    info__data: {
      get() {
        return MiniInfoBlock().get()
      },
      set(value) {
        MiniInfoBlock().set(value)
      }
    },
    selected_filters() {
      return FiltersBlock().selected()
    },
    maintenance: {
      get() {
        return Mai_Documents().get()
      },
      set(value) {
        Mai_Documents().set(value)
      }
    },
    registered: {
      get() {
        return Reg_Documents().get()
      },
      set(value) {
        Reg_Documents().set(value)
      }
    },
    appeals: {
      get() {
        return App_Documents().get()
      },
      set(value) {
        App_Documents().set(value)
      }
    },
    deleted: {
      get() {
        return Del_Documents().get()
      },
      set(value) {
        Del_Documents().set(value)
      }
    },
    tab: {
      get() {
        return LeftDrawer().get()
      },
      set(value) {
        LeftDrawer().set(value)
      }
    },
  }
}
</script>

<style scoped>
.bigger {
  font-size: 25px !important;
}

.my-icon-button {
  transition: 0.2s;
}
.my-icon-button:hover {
  background-color: #e6e6e6;
  color: #0c9d18 !important;
}

</style>
